<div mat-dialog-title>
  Installeer de app op je apparaat
</div>
<div mat-dialog-content>
  <ng-container *ngIf="pwaInstallService.isIos()">
    <p>Zo voeg je deze app toe aan je beginscherm:</p>
    <ol>
      <li>
        Tik op de <strong>Deel‑knop</strong> <mat-icon class="inline-icon">ios_share</mat-icon> in de werkbalk van Safari.
      </li>
      <li>Scroll naar beneden en tik op <strong>"Zet op beginscherm"</strong>.</li>
      <li>Tik op <strong>"Voeg toe"</strong> rechtsboven in het scherm.</li>
    </ol>
  </ng-container>
  <ng-container *ngIf="!pwaInstallService.isIos()">
    <p>Installeer {{ environment.webappName }} voor een snellere ervaring in volledig scherm.</p>
  </ng-container>
</div>
<mat-dialog-actions>
  <button [mat-dialog-close]="false" color="accent" mat-raised-button>Niet meer tonen</button>
  <button [mat-dialog-close]="true" color="primary" mat-raised-button>
    <ng-container *ngIf="pwaInstallService.isIos()">Begrepen</ng-container>
    <ng-container *ngIf="!pwaInstallService.isIos()">Installeren</ng-container>
  </button>
</mat-dialog-actions>
